import React, { useEffect, useState } from "react";
import Footer from '../components/footer';
import { useMoralis } from "react-moralis";
import { configs } from '../../configs/web3.config';
import axios from 'axios';
import UserIdenticon from "../commons/UserIdenticon";
import { getEllipsisTxt, getSliceLongTxt } from "../../helpers/formatters"
import Select from 'react-select'
import { toast } from 'react-toastify'
import { useWeb3React } from '@web3-react/core';
import { Contract } from '@ethersproject/contracts';
import { Modal, ModalHeader, ModalBody } from 'reactstrap'
import { Link } from '@reach/router';
import { useNavigate } from "@reach/router"
import { getFileTypeFromURI } from '../../helpers/fileTypeDecoder'
import { DateTime } from "luxon";


const customStyles = {
  option: (base, state) => ({
    ...base,
    background: "#212428",
    color: "#fff",
    borderRadius: state.isFocused ? "0" : 0,
    "&:hover": {
      background: "#16181b",
    }
  }),
  menu: base => ({
    ...base,
    background: "#212428 !important",
    borderRadius: 0,
    marginTop: 0
  }),
  menuList: base => ({
    ...base,
    padding: 0
  }),
  control: (base, state) => ({
    ...base,
    padding: 2
  })
};

const options = [
  { value: '-1', label: 'All categories' },
  { value: '1', label: 'Uncategorized' },
  { value: '2', label: 'Abstract' },
  { value: '3', label: 'Digital Art' },
  { value: '4', label: 'Photography' },
  { value: '5', label: '3D Animation' },
  { value: '6', label: 'Exclusive Drops' },
]



const SellNFTDetails = function ({ contractAddress, tokenId }) {

  const { Moralis, isInitialized } = useMoralis()
  const navigate = useNavigate()
  const [isProfileDataLoading, setIsProfileDataLoading] = useState(false)
  const [isNFTDataLoading, setIsNFTDataLoading] = useState(false)
  const [nftOwnerData, setNftOwnerData] = useState({})
  const [nftMetaData, setNftMetaData] = useState({})
  const [nftPrice, setNftPrice] = useState(0.0)
  const [nftCategory, setNftCategory] = useState('1')

  const [nftImage, setNftImage] = useState('')
  const [nftTitle, setNftTitle] = useState('~')

  const { account, active, library } = useWeb3React()

  const [showNFTListModal, setShowFTListModal] = useState(false)
  const [successMsg, setSuccessMsg] = useState('')
  const [sellNFTLoading, setsellNFTLoading] = useState(false)
  const [nftContentType, setNftContentType] = useState('')
  const [nftListingFee, setNftListingFee] = useState(0)
  const [isCheckBoxSelect, setIsCheckBoxSelect] = useState(false)

  const { web3Config } = configs


  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {
    if (library) {
      await getMarketplaceListingFeePercentage()
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [library])

  const getUsername = (moralisAttributes) => {

    if (moralisAttributes) {
      if ("username" in moralisAttributes && moralisAttributes.username !== "") {
        return getSliceLongTxt(moralisAttributes.username, 60)
      } else {
        return getEllipsisTxt(moralisAttributes.walletAddress, 7)
      }
    } else {
      return ''
    }
  }

  const getTokenCreatorProfile = async (walletAddress) => {
    try {
      setIsProfileDataLoading(true)
      const params = { walletAddress };
      const profileDataResponse = await Moralis.Cloud.run("getCreatorDetailsByAddress", params);
      setNftOwnerData(profileDataResponse)
      setIsProfileDataLoading(false)
    } catch (error) {
      setIsProfileDataLoading(false)
      console.error("MORALIS ERROR while fetching profile data ", error)
    }
  }

  const getNFTMetaData = async () => {
    try {
      setIsNFTDataLoading(true)
      const options = { address: contractAddress, token_id: tokenId, chain: web3Config.moralisChainId };
      const tokenIdMetadataResponse = await Moralis.Web3API.token.getTokenIdMetadata(options);
      setNftMetaData(tokenIdMetadataResponse)
      setIsNFTDataLoading(false)
    } catch (error) {
      setIsNFTDataLoading(false)
      setNftMetaData({})
      console.error("MORALIS ERROR while fetching NFT metadata ", error)
    }
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {
    try {
      if (isInitialized) {
        await getNFTMetaData()
      }
    } catch (error) {
      console.error("MORALIS ERROR error while fetching your NFTS ", error)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contractAddress, tokenId, isInitialized])

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {
    try {
      if (isInitialized) {
        await getTokenCreatorProfile(nftMetaData.owner_of)
      }
    } catch (error) {
      console.error("MORALIS ERROR error while fetching nft owner data ", error)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nftMetaData, isInitialized])


  const handleCategorySelect = (selectedCategory) => {
    setNftCategory(selectedCategory.value)
  }

  const handleChangeCheck = () => {
    setIsCheckBoxSelect(true)
  }
  const handleListNFT = async () => {

    if (!nftPrice || nftPrice === 0) {
      toast.dark('Please enter the valid listing price', {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

      return
    }

    if (!nftCategory) {
      toast.dark('Please select the category', {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

      return
    }

    if (!account && !active) {
      toast.dark('Please connect your wallet to list your NFT', {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

      return
    }

    if (!isCheckBoxSelect) {
      toast.dark('Please select the checkbox', {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

      return
    }
    setsellNFTLoading(true)
    setShowFTListModal(true)
    setSuccessMsg('STEP : [1/2] Please wait we are processing your NFT transaction')
    await approveTransaction(nftMetaData.token_address, nftMetaData.token_id)
    await listNFTForSale(nftMetaData.token_address, nftMetaData.token_id, nftPrice)
  }

  const approveTransaction = async (tokenAddress, tokenId) => {

    try {
      const { web3Config } = configs
      const nftMarketplaceContractAddress = web3Config.nftMarketPlaceAddress
      const erc721ContractAbi = JSON.parse(web3Config.erc721ContractAbi)
      //first create te erc721 contract address and approve the transaction
      const erc721Contract = new Contract(tokenAddress, erc721ContractAbi, library.getSigner())
      const approveTx = await erc721Contract.approve(nftMarketplaceContractAddress, tokenId)
      await approveTx.wait()
      setSuccessMsg('STEP : [2/2] Hold on! we are listing your NFT in our marketplace')

    } catch (error) {
      console.error('Approve tx error', error)
      setSuccessMsg('Approve tx error')
      setsellNFTLoading(false)
      setTimeout(() => {
        setShowFTListModal(false)
      }, 2000);
    }
  }

  const getMarketplaceListingFeePercentage = async () => {
    try {
      const { web3Config } = configs
      const nftMarketplaceContractAddress = web3Config.nftMarketPlaceAddress
      const marketplaceContractABI = JSON.parse(web3Config.nftMarketPlaceContractAbi)
      const marketplaceContract = new Contract(nftMarketplaceContractAddress, marketplaceContractABI, library.getSigner())

      const listingFee = await marketplaceContract.listingFeePercentage()
      const percentageValueInInt = parseInt(listingFee.toString())
      setNftListingFee(percentageValueInInt)
    } catch (error) {
      setNftListingFee(0)
      console.log("ERROR : while fetching marketplace listing fee : ", error)
    }
  }

  const listNFTForSale = async (tokenAddress, tokenId, price) => {

    try {
      const { web3Config } = configs
      const nftMarketplaceContractAddress = web3Config.nftMarketPlaceAddress
      const marketplaceContractAbi = JSON.parse(web3Config.nftMarketPlaceContractAbi)
      const contract = new Contract(nftMarketplaceContractAddress, marketplaceContractAbi, library.getSigner())

      //added listing fee to price
      const listingFeeInBNB = price * (nftListingFee / 100)
      const listingFeeInWei = parseFloat(listingFeeInBNB) * (`1e${18}`)
      const formattedPrice = price * (`1e${18}`)

      const actualPriceInBNB = Number(formattedPrice).toLocaleString('fullwide', { useGrouping: false })
      const actualFeeInBNB = Number(listingFeeInWei).toLocaleString('fullwide', { useGrouping: false })

      const createMarketTx = await contract.createMarketItem(
        tokenAddress.toLowerCase(),
        tokenId,
        actualPriceInBNB,
        nftCategory,
        { value: actualFeeInBNB }
      )
      await createMarketTx.wait()
      toast.dark('Congratulation your NFT has been listed in our marketplace', {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      setTimeout(() => {
        setShowFTListModal(false)
      }, 1000);
      setsellNFTLoading(false)
      navigate('/gallery')
    } catch (error) {
      console.error('NFT listing error', error)
      toast.dark('Something went wrong while listing your NFT please check your account and network', {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      setNftPrice(null)
      setTimeout(() => {
        setShowFTListModal(false)
      }, 2000);
      setsellNFTLoading(false)
    }

  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {
    if (nftMetaData.metadata) {
      const metadata = JSON.parse(nftMetaData.metadata)
      let processedImageUrl = ''
      if (metadata.image && metadata.image.includes('ipfs://')) {
        const imageUrl = metadata.image.split('ipfs://')
        processedImageUrl = `https://hodl4gold.mypinata.cloud/ipfs/${imageUrl[1]}`
      } else {
        processedImageUrl = metadata.image
      }

      // get the file content type 
      const contentType = await getFileTypeFromURI(processedImageUrl)
      setNftContentType(contentType || '')
      setNftImage(processedImageUrl)
      setNftTitle(metadata.name || '~')
    } else {
      if (nftMetaData.token_uri) {
        const response = await axios.get(nftMetaData.token_uri)
        if (response.status === 200) {
          const metadata = response.data
          let processedImageUrl = ''
          if (metadata.image && metadata.image.includes('ipfs://')) {
            const imageUrl = metadata.image.split('ipfs://')
            processedImageUrl = `https://hodl4gold.mypinata.cloud/ipfs/${imageUrl[1]}`
          } else {
            processedImageUrl = metadata.image
          }

          // get the file content type 
          const contentType = await getFileTypeFromURI(processedImageUrl)
          setNftContentType(contentType || '')
          setNftImage(processedImageUrl)
          setNftTitle(metadata.name || '~')
        }
      } else {
        setNftImage('')
        setNftTitle('~')
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nftMetaData])

  const toggleNFTListModal = () => {
    if (showNFTListModal) {
      setShowFTListModal(false)
    } else {
      setShowFTListModal(true)
    }
  }
  return (
    <div>
      {
        isNFTDataLoading ? (
          <div className='row mt-4 mb-4'>
            <div className='col-lg-12'>
              <div className='loading-container'>
                <div className="spinner-grow" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <section className='container'>
            <div className='row mt-md-5 pt-md-4'>

              <div className="col-md-6 text-center">
                {
                  nftContentType.includes('audio') ? (
                    <div>
                      <audio controls>
                        <source src={nftImage} type={nftContentType} />
                      </audio>
                    </div>
                  ) : (<></>)
                }

                {
                  nftContentType.includes('image') ? (
                    <img src={nftImage} alt={nftTitle} className="img-fluid img-rounded mb-sm-30" />
                  ) : (<></>)
                }
              </div>
              <div className="col-md-6">
                <div className="item_info">
                  Token Created At
                  <div className="de_countdown">
                    {nftMetaData ? DateTime.fromISO(nftMetaData.synced_at).toFormat('ff') : ''}
                  </div>
                  <h2>{nftTitle}</h2>
                  <div className="item_info_counts">
                    <div className="item_info_type"><i className="fa fa-image"></i>{nftMetaData.contract_type}</div>
                    <div className="item_info_views"><i className="fa fa-eye"></i>Token ID # {nftMetaData.token_id}</div>
                    <div className="item_info_like"><i className="fa fa-heart"></i>Token Symbol : {nftMetaData.symbol}</div>
                  </div>
                  <h6>Creator</h6>
                  <div className="item_author">
                    <div className="author_list_pp">
                      <span>
                        <UserIdenticon size="50" walletAddress={nftMetaData.owner_of} customCss={{ width: '50px', height: '50px' }} />
                        <i className="fa fa-check"></i>
                      </span>
                    </div>
                    <div className="author_list_info">

                      {
                        isProfileDataLoading ?
                          (
                            <span>
                              <div className="spinner-grow spinner-grow-sm" role="status">
                                <span className="sr-only">Loading...</span>
                              </div>
                            </span>
                          ) :
                          (
                            <span>
                              {getUsername(nftOwnerData ? nftOwnerData.attributes : null)}
                            </span>
                          )
                      }

                    </div>
                  </div>

                  <div className="spacer-40"></div>
                  <div className="alert alert-warning mt-2" role="alert">
                    {nftListingFee} % transaction fee
                  </div>
                  <div className="de_tab">
                    <div className="row">
                      <div className="col-sm-12 col-md-12 col-lg-12 mb-3">
                        <div className='dropdownSelect one'>
                          <Select className='select1'
                            styles={customStyles}
                            menuContainerStyle={{ 'zIndex': 999 }}
                            defaultValue={options[0]} options={options}
                            onChange={handleCategorySelect} />
                        </div>
                      </div>

                      <div className="col-sm-12 col-md-12 col-lg-12">
                        <input className="form-control" id="name_1" name="nftPrice" onChange={e => setNftPrice(e.target.value)} placeholder="Enter your NFT Listing Price (BNB)" type="number" min="0" />
                      </div>

                      <div className="col-sm-12 col-md-12 col-lg-12">
                        <input type="checkbox" defaultChecked={false} onChange={handleChangeCheck} />
                        <span className="checkbox-content">
                          Once you list your NFT, you will not be able to edit or update any of its information and all listings are final.
                          You agree that any information uploaded will not contain material subject to copyright or other proprietary rights unless you have necessary permission or are otherwise legally entitled to post the material.
                        </span>
                      </div>

                      <div className="col-sm-6 col-md-6 col-lg-6 mt-3">
                        <div className="list-nft-btn" onClick={handleListNFT}>
                          {
                            !sellNFTLoading ? (
                              <div className="btn-rounded">
                                List your NFT
                              </div>
                            ) : (
                              <div className='row'>
                                <div className='col-lg-12'>
                                  <div className='loading-container'>
                                    <div className="spinner-grow" role="status">
                                      <span className="sr-only">Loading...</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )
                          }

                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>

            </div>
            <Modal
              isOpen={showNFTListModal}
              toggle={() => toggleNFTListModal()}
              className='modal-dialog-centered'
              backdrop={false}
            >
              <ModalHeader toggle={() => toggleNFTListModal()}>
                <div className="connect-modal-title">You are listing {nftTitle} </div>
              </ModalHeader>
              <ModalBody className='login-model-body'>
                <div className='profile-action-container'>
                  <span>
                    <div className='row'>
                      <div className='col-lg-12'>
                        <div className='loading-container'>
                          <div className="spinner-grow" role="status">
                            <span className="sr-only">Loading...</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    {successMsg}
                  </span>
                </div>
              </ModalBody>
            </Modal>
          </section>
        )
      }

      <Footer />
    </div>
  );
}
export default SellNFTDetails;